import { writable } from 'svelte/store';

export const activePage = writable({page: "home"})
export const staticPath = writable('')